import { Typography } from '@mui/material';

type Props = {
	content: string;
};

const HintMsg = ({ content }: Props) => <Typography variant="subtitle2">{content}</Typography>;

export default HintMsg;
